import React, { useEffect, useState,useRef } from "react";
import { ButtonCustom } from '../../../BootstrapComponents/ButtonCustom'
import styles from './styles.module.css'
import { MdOutlineSecurity } from "react-icons/md";
import CreatePermission from './CreatePermission';
import { toast, ToastContainer } from "react-toastify";
import { BreathAPIs } from "../../../APIs/BreathAPIs";
import {Table, Switch, Divider, Button,Tag,Space,Input,Modal,Form } from "antd";
import {  MinusCircleOutlined,PlusOutlined} from "@ant-design/icons";
import { AiFillDelete } from "react-icons/ai";


function Permissions() {
    const [showAddPermissionModel, setShowAddPermissionModel] = useState(false);
    const [permissionData, setPermissionData] = useState([]);
    const [pagination, setPagination] = useState({
        total: 0,
        current: 1,
        pageSize: 10,
        totalPages: 0
      });
      const [screenWidth, setScreenWidth] = useState(window.innerWidth);
      const [showModifyPermissionValuesModal,setShowModifyPermissionValuesModal] = useState(false);
      const [currentPermission,setCurrentPermission] = useState({});
      const [isLoading,setIsLoading] = useState(true)
      const [form] = Form.useForm();



      const handleTableChange = (pagination) => {
        const { current, pageSize } = pagination;
        fetchPermissions(current, pageSize);
      };

      async function fetchPermissions(page = 1, pageSize = 10) {
        try {
          setIsLoading(true)
          let result = await BreathAPIs.getUserPermissionsList( { page: page, limit: pageSize});
          // console.log("userGroupResponse", userGroupResponse)
          // console.log(result)
          setPermissionData(result.data.response.permissions);
          setPagination({
            total: result.data.response.pagination.total,
            current:result.data.response.pagination.current,
            pageSize:result.data.response.pagination.pageSize,
            totalPages:result.data.response.pagination.totalPages
        });
        setIsLoading(false)
        } catch (error) {
          console.error(error.message);
        }
      }

      const setStatus = (record, checked) => {
        try {
          // console.log('record: ',record);
          // console.log('checked: ',checked);
    
          const updatedPermissions = permissionData.map((permission) => {
            if (permission._id === record._id) {
              return { ...permission, allowChildPermissions: checked };
            }
            return permission;
          });
          setPermissionData(updatedPermissions);
          // console.log('updated user group: ',updatedUserGroup);
        } catch (error) {
          toast.error(error.message);
        }
      };

      const handleModalClose = () =>{
        form.resetFields();
        setCurrentPermission({});
        setShowModifyPermissionValuesModal(!showModifyPermissionValuesModal)

      }

      const submitPermissionValuesModification=()=>{
         form
            .validateFields() // Validate all fields
            .then( (values) => {
        
              // console.log('values: ',values)
              const { items } = values;
        
              if (!items || items.length === 0) {
                toast.error('Please add at least one permission value');
                return;
              }
             
            
              setPermissionData(permissionData.map(
                (permission)=>permission._id===currentPermission._id?
                {...permission,permissionValues:items}
                :
                permission)
            )
            handleModalClose()
         

            })
            .catch((errorInfo) => {
              console.error('Validation Failed:', errorInfo.message ? errorInfo.message : 'Required number of permission values not selected');
              // toast.error(response.data.message)
              toast.error(errorInfo?.response?.data?.message || 'Something went wrong')
            });
      }

      const updatePermission = async (selectedPermission)=>{

        try {
          
          const response = await BreathAPIs.updatePermission(selectedPermission)
                    response.status === 200
                    ? toast.success(response.data.message)
                    : toast.error(response.data.message);
        } catch (error) {

          console.error(error.message)
        }

      }

      const deletePermission = async (selectedPermission)=>{

        try {
          
          const response = await BreathAPIs.deletePermission(selectedPermission)
                    // response.status === 200
                    // ? toast.success(response.data.message)
                    // : toast.error(response.data.message);
          // console.log('response: ',response)
          if(response.status===200){
            
            setPermissionData(permissionData.filter((permission)=>permission._id!==selectedPermission._id))
            toast.success(response.data.message)
          }
           
        } catch (error) {
          toast.error(error.response.data.message);
          console.error(error.message)
        }

      }
    
      useEffect(() => {
        const handleResize = () => {
          setScreenWidth(window.innerWidth); 
        };
      
        // Add event listener on component mount
        window.addEventListener('resize', handleResize);
      
        // Clean up event listener on component unmount
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);

      useEffect(() => {
        fetchPermissions();
        
      }, []);

   

      const permissionColumn = 
[
    {
      title: "Permission Name",
      dataIndex: "permissionName",
      key: "permissionName",
      render: (text, record) => (
        <span style={{fontWeight:500}}> {record.permissionName !== null ? record.permissionName : " "}</span>
      ),
      width: screenWidth>768?'12.5vw':'25vw',
      fixed: 'left',
    },
    {
      title: "Allow Child Permissions",
      dataIndex: "allowChildPermissions",
      key: "allowChildPermissions",
      render: (text, record) => (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "0px 15px",
            minWidth:'215px'
          }}
        >
          <div>
          <Tag color={record.allowChildPermissions?'green':'red'}>{record.allowChildPermissions?'True':'False'}</Tag>
          </div>
          <div>
            <Switch
              onChange={(checked) => {
                setStatus(record, checked);
              }}
              checked={record.allowChildPermissions}
            />
          </div>
        </div>
      ),
      width: 200,
      // fixed: 'left',
    },

    {
      title: "Permission Values",
      dataIndex: "permissionValues",
      key: "permissionValues",
      render: (text, record) => (
        <div className={styles['permission-scrollbar']}>
       
          {record.permissionValues.map(
                (permissionValue,index,entries) => (
                  <div key={index}>
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems:'center',
                       width:'100%'
                      }}
                    >
                      <div>
                        <span style={{ fontStyle: "italic"}}>{permissionValue}</span>
                      </div>
                    </div>
                    <div>{index < entries.length - 1 ? <Divider style={{margin:'10px 0px'}}/> : null}</div>
                  </div>
                )
              )
            || "No permission Values available"}
        </div>
      ),
      width: 200,
      // fixed: 'left',
    },
    {
            render: (text, record) => (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  type="primary"
                  onClick={()=>{
                    //form.resetFields()  ;
                     setCurrentPermission(record);setShowModifyPermissionValuesModal(!showModifyPermissionValuesModal);}}
                >
                Add / Modify Permission Value(s)
                </Button>
                
              </div>
            ),
            width: 250,
          },
    
    {
      render: (text, record) => (
        <div style={{ display:'flex',flexDirection:'column'}}>
          <Button
          style={{margin:'7.5px'}}
            onClick={() => {
              updatePermission(record);
            }}
            type="primary"
          >
            Update
            </Button>
              
          <Button
           style={{margin:'7.5px'}}
          //  shape="circle"
          //  icon={<AiFillDelete></AiFillDelete>}
            onClick={() => {
              deletePermission(record);
            }}
            type="primary"

             danger
          >
            Delete
            </Button>
          
          
        </div>
      ),
      width: 115,
      fixed:screenWidth>768?'right':null
    }
  ];


    return (
        <>
                  <ToastContainer> </ToastContainer>        
            <div className={styles['add-permissions-btn']}>
                <ButtonCustom text={"Create Permission "} icon={<MdOutlineSecurity />} onClick={()=>setShowAddPermissionModel(!showAddPermissionModel)}></ButtonCustom>
                    <CreatePermission showAddPermissionModel={showAddPermissionModel} setShowAddPermissionModel={setShowAddPermissionModel} setPermissionData={setPermissionData}/>
                
            </div>
            <div style={{marginTop:'15px'}}>
            <Table
                loading={isLoading}
                dataSource={permissionData}
                columns={permissionColumn}
                rowKey="_id"
                pagination={pagination}
                onChange={handleTableChange}
                bordered
                size="middle"
                scroll={{ x: 'calc(600px + 50%)'}}
                />
                
            </div>
            
            {currentPermission &&
            
            <Modal
            title="Modify Permission Values"
            open={showModifyPermissionValuesModal}
            onCancel={()=>{handleModalClose()}}
            onOk={()=>{
              //setShowModifyPermissionValuesModal(!showModifyPermissionValuesModal);
              submitPermissionValuesModification()}}
            okText='Submit'
            >
              <> 

            <Form
              form={form}
              // initialValues={{
              //   items: currentPermission.permissionValues || [],
              // }} 
              initialValues={{items:[]}}     
              >

              {
                currentPermission && showModifyPermissionValuesModal &&
                <>
              {form.setFieldsValue({ items: currentPermission.permissionValues || [] })}

                
              <Form.List
                name="items"
              >
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, fieldKey, ...restField }) => (
                      <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                        <Form.Item
                          {...restField}
                          name={name}
                          fieldKey={fieldKey}
                          rules={[{ required: true, message: 'This field is required' }]}
                        >
                          <Input placeholder="Enter a value" />
                        </Form.Item>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </Space>
                    ))}
                    <Form.Item>
                      <Button onClick={() => add()} block icon={<PlusOutlined />}>
                        Add Permission Value
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
              </>
              }
            </Form>
              
              </>
            </Modal>
            
            }
        </>
    )
}

export default Permissions